module.exports = __webpack_public_path__ + "assets/img/TrendingNow_solution.b30529a1-ps.jpg";